module.exports = __webpack_public_path__ + "c13f4ad3813f0db0aaf225fea38f55bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/assets/images/ProductionShiftReportSection1.png
// module id = 313
// module chunks = 0